import React, { Component } from 'react';
import { compose } from 'recompose';
// import Button from '@material-ui/core/Button';
import { withAuthorization } from '../../components/Session';
import { withFirebase } from '../../components/Firebase';
import { withStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import AdminNavigation from '../../components/AdminNavigation';
import * as ROUTES from '../../constants/routes';
import * as ROLES from '../../constants/roles';

import UserIndexPage from '../Users/index';
import UserEditPage from '../Users/edit';
import UserNewPage from '../Users/new';

import FreightForwarderIndexPage from '../FreightForwarder/index';
import FreightForwarderEditPage from '../FreightForwarder/edit';
import FreightForwarderNewPage from '../FreightForwarder/new';

import { Route, Switch } from 'react-router-dom';

const styles = theme => ({
    root: {
        // margin: theme.spacing(4)
        flexGrow: 1,
        display: 'flex',
        flexWrap: 'wrap',
        padding: '12px'
    }
});

class AdminPage extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {}

    render() {
        const { classes } = this.props;

        return (
            <div className={classes.root}>
                <Grid container spacing={3}>
                    <Grid item xs={3}>
                        <AdminNavigation />
                    </Grid>
                    <Grid item xs={9}>
                        <Switch>
                            {/* *************************USERS ****************************** */}

                            <Route exact path={ROUTES.USERS} render={props => <UserIndexPage {...props} />} />
                            <Route exact path={ROUTES.USERS_NEW} render={props => <UserNewPage {...props} />} />
                            <Route
                                exact
                                path={ROUTES.USER}
                                render={props => {
                                    return <UserEditPage {...props} user_id={props.match.params.user_id} />;
                                }}
                            />

                            {/* *************************FREIGHT_FORWARDERS_ADMIN ****************************** */}

                            <Route exact path={ROUTES.FREIGHT_FORWARDERS_ADMIN} render={props => <FreightForwarderIndexPage {...props} />} />
                            <Route exact path={ROUTES.FREIGHT_FORWARDERS_NEW} render={props => <FreightForwarderNewPage {...props} />} />
                            <Route
                                exact
                                path={ROUTES.FREIGHT_FORWARDER_EDIT}
                                render={props => {
                                    return <FreightForwarderEditPage {...props} freight_forwarder_id={props.match.params.freight_forwarder_id} />;
                                }}
                            />
                        </Switch>
                    </Grid>
                </Grid>
            </div>
        );
    }
}

const condition = authUser => authUser && authUser.roles && authUser.roles.includes(ROLES.ADMIN);

export default compose(withFirebase, withAuthorization(condition), withStyles(styles, { withTheme: true }))(AdminPage);
